var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconVer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8.96141 8 9.88344 7.61808 10.5633 6.93826C11.2431 6.25844 11.625 5.33641 11.625 4.375C11.625 3.41359 11.2431 2.49156 10.5633 1.81174C9.88344 1.13192 8.96141 0.75 8 0.75C7.03859 0.75 6.11656 1.13192 5.43674 1.81174C4.75692 2.49156 4.375 3.41359 4.375 4.375C4.375 5.33641 4.75692 6.25844 5.43674 6.93826C6.11656 7.61808 7.03859 8 8 8ZM10.4167 4.375C10.4167 5.01594 10.1621 5.63063 9.70884 6.08384C9.25563 6.53706 8.64094 6.79167 8 6.79167C7.35906 6.79167 6.74437 6.53706 6.29116 6.08384C5.83795 5.63063 5.58333 5.01594 5.58333 4.375C5.58333 3.73406 5.83795 3.11937 6.29116 2.66616C6.74437 2.21295 7.35906 1.95833 8 1.95833C8.64094 1.95833 9.25563 2.21295 9.70884 2.66616C10.1621 3.11937 10.4167 3.73406 10.4167 4.375ZM15.25 14.0417C15.25 15.25 14.0417 15.25 14.0417 15.25H1.95833C1.95833 15.25 0.75 15.25 0.75 14.0417C0.75 12.8333 1.95833 9.20833 8 9.20833C14.0417 9.20833 15.25 12.8333 15.25 14.0417ZM14.0417 14.0368C14.0405 13.7396 13.8556 12.8454 13.0363 12.0262C12.2485 11.2383 10.7659 10.4167 8 10.4167C5.23292 10.4167 3.7515 11.2383 2.96367 12.0262C2.14442 12.8454 1.96075 13.7396 1.95833 14.0368H14.0417Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconVer2);
export default __webpack_public_path__ + "static/media/profile-icon-ver-2.a8dee179c2de9ed62926bb1569af7239.svg";
export { ForwardRef as ReactComponent };